import { useEffect, useState } from 'react';
import { api } from '../lib/api.ts';
import { Field, Modal, useToast } from '../ui.tsx';
import type { Customer } from '../lib/types.ts';

/**
 * ค้นหาสมาชิก — เปิดจากปุ่ม "สมาชิก" ในตะกร้า
 *
 * ★ สมาชิกใช้ร่วมกันทั้งสองสาขา ★ ค้นจากชื่อ เบอร์ หรือรหัส
 * เหมือน API เดิมที่ค้นทั้งสามอย่างพร้อมกัน
 */
export function MemberModal({
  onPicked,
  onClose,
}: {
  onPicked: (customer: Customer) => void;
  onClose: () => void;
}) {
  const toast = useToast();
  const [search, setSearch] = useState('');
  const [results, setResults] = useState<Customer[]>([]);

  useEffect(() => {
    const term = search.trim();
    if (term.length < 2) {
      setResults([]);
      return;
    }
    const timer = setTimeout(() => {
      api
        .get<{ customers: Customer[] }>('/customers', { search: term, limit: 20 })
        .then((r) => setResults(r.customers))
        .catch((err: Error) => toast(err.message, 'crit'));
    }, 250);
    return () => clearTimeout(timer);
  }, [search, toast]);

  return (
    <Modal title="เลือกสมาชิก" onClose={onClose}>
      <Field label="ค้นจากชื่อ เบอร์โทร หรือรหัสสมาชิก">
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="พิมพ์อย่างน้อย 2 ตัวอักษร"
          autoFocus
        />
      </Field>

      <div className="rowlist">
        {results.map((customer) => (
          <button key={customer.id} className="rowitem" onClick={() => onPicked(customer)}>
            <span className="grow">
              <strong>{customer.name}</strong>
              <div className="sub">
                {customer.phone || customer.code}
                {customer.memberDiscountPct > 0 && ` · ลด ${customer.memberDiscountPct}%`}
              </div>
            </span>
          </button>
        ))}
      </div>

      {search.trim().length >= 2 && results.length === 0 && (
        <div className="empty">ไม่พบสมาชิก</div>
      )}
    </Modal>
  );
}
